import { render, staticRenderFns } from "./PurchaseDomain.vue?vue&type=template&id=6311c92a&scoped=true"
import script from "./PurchaseDomain.vue?vue&type=script&lang=js"
export * from "./PurchaseDomain.vue?vue&type=script&lang=js"
import style0 from "./PurchaseDomain.vue?vue&type=style&index=0&id=6311c92a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6311c92a",
  null
  
)

export default component.exports